import {
    IAttributes,
    IAugmentedJQuery,
    IDirective,
    IDirectiveFactory,
    ILogService,
    INgModelController,
    IScope,
    ITimeoutService
} from "angular";

export class ArrayLengthValidator implements IDirective {
    public link: (scope: IScope,
                  element: IAugmentedJQuery, attrs: IAttributes, controller: INgModelController) => void;
    public restrict = "AE";
    public require  = "ngModel";
    public scope = true;

    /* @ngInject */
    public static factory(): IDirectiveFactory {
        const directive: IDirectiveFactory = ($timeout: ITimeoutService, $log: ILogService) => new ArrayLengthValidator($timeout, $log);
        directive.$inject = ["$timeout", "$log"];
        return directive;
    }



    /* @ngInject */
    constructor(private $timeout: ITimeoutService, private $log: ILogService) {

        ArrayLengthValidator.prototype.link = (
            scope: IScope,
            elem: IAugmentedJQuery,
            attrs: IAttributes,
            controller: INgModelController) => {

            scope.$watch(() => {
                return controller.$modelValue && controller.$modelValue.length;
            }, () => {
                controller.$validate(); // validate again when array changes
            });

            controller.$validators.arrayLengthValidator = (modelValue: any, viewValue: any) => {

                const arr = controller.$modelValue;
                if (!arr) { return false; }

                return arr.length > 0;
            };
        };
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/prior-study/array-length-validator.ts